// extracted by mini-css-extract-plugin
export default {"glass":"Profile_glass__TDRpn","profile_img":"Profile_profile_img__HTK62","textbox":"Profile_textbox__Rg7uf"};